import React, { createElement } from 'react';
import { ROLES } from './constants';

const TabPanel = ({ children, render }) => (
  <div className="TabbedView-tabPanel">
    {render ? createElement(render) : children}
  </div>
);

TabPanel.role = ROLES.TAB_PANEL;

export default TabPanel;
